import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';
import {AuthService} from '../services/auth.service'
import {Router,ActivatedRoute} from '@angular/router';

import domtoimage from 'dom-to-image';


declare var $: any;
@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.css']
})
export class TemplateComponent implements OnInit {
  categories;
  projects;
  project_list;
  category_list;
  template_name;
  mail_subject;
  content_type;
  content;
  contents;
  contents_original;

  preview_content;

  bool_add = false;
  bool_list = false;
  bool_edit = false;

  html_to_img = true;

  href = "";

  constructor(public authService :  AuthService,private route : Router,  private routeActive: ActivatedRoute) { }

  ngOnInit() {
    
   
    this.bool_edit = false;

    this.href = this.route.url;  
       
    this.getProjects();
    this.preview_content = "";
    setTimeout(function(){
      $('#summernote').summernote();    
    },0)

    if(this.href=="/template/add"){
      this.bool_add = true;
      this.bool_list = false;
     // loadNotepad();
    }else if(this.href.includes("/template/edit")){
     
      let template_id = this.routeActive.snapshot.paramMap.get('id');  


     // this.bool_edit = true;
     this.bool_edit = true;
     this.bool_add = true;
     this.bool_list = false;
     this.getTemplate(template_id)
     // loadNotepad();
    }else{
      this.bool_add = false;
      this.bool_list = true;
      //this.listTempate();
    }
  }


  getTemplate(template_id) {
    this.authService.getTemplate({template_id}).subscribe((data: any) => {
      if (data.error) {        
        console.log(data.error);        
      } else {
        //this.projects = data.data;    
        let obj = data.data;
        
        this.project_list = obj.project._id;
        this.getCategories( this.project_list);

        this.category_list = obj.category._id;
        this.content_type = obj.content_type;
        this.mail_subject = obj.subject;
        this.template_name = obj.name;
        $('#summernote').summernote('code', obj.content);
      }
    });
  }

  getProjects(args = {}) {
    this.authService.getProjects(args).subscribe((data: any) => {
      if (data.error) {        
        console.log(data.error);        
      } else {
        this.projects = data.data;           
      }
    });
  }

  getCategories(project_id) {
    if (project_id && project_id != "") {
      this.authService
        .listCategory({ project: project_id })
        .subscribe((data: any) => {
          if (data.error) {
            console.log(data.error);
          } else {
            this.categories = data.data;                       
          }
        });
    } else {
      this.categories = [];
    }
    //return;
  }


 

  deleteTemplate(id) {

    var txt;
    if (confirm("Would you like to proceed !")) {
  
      this.authService.deleteTemplate({id:id}).subscribe((data: any) => {
        if (data.error) {
          swal("OOPs!", data.message, "error");
          //this.approver_delete_msg = data.message;
        } else {
          swal("Success", data.message, "success");
          this.listTempate();        
         
        }
      });
    } else {
     return;
    }
  
       
  }


  

  listTempate(){
  
    let project_id = this.project_list;
    let category_id = this.category_list;   
    
    let req_obj = {
      project : project_id,
      category : category_id   
    } 

    this.authService.listTemplate(req_obj).subscribe((res:any) =>{
      if(res.error){
       // swal("Ooops!!",res.message,"error");
       console.log(res.error);
        return;
      }

      this.contents = res.data;

      /* if(this.bool_list){
        this.contents_original = res.data;
        console.log("this.contents_original===============");
        console.log(this.contents_original);
        
        let filter_data = res.data;
        var self = this;
        
        setTimeout(function(){
          filter_data = processContentOriginal(res.data);
       
          self.contents = filter_data;
          self.contents_original = [];         
        },500);        
       
        return;
      } */
   
      this.contents = res.data;
      //swal("Success",res.message,"success");

    })
  }
 

  submitTemplate(){
   
    let project_id = this.project_list;
    let category_id = this.category_list;
    let template_name = this.template_name;
    let mail_subject = this.mail_subject;
    let content_type  = "HTML";
    let content = $("#summernote").summernote('code');  
  
    let req_obj = {
      project : project_id,
      category : category_id,
      content_type : content_type,
      content : content,
      template_name : template_name,
      mail_subject : mail_subject
    }    
    this.authService.addTemplate(req_obj).subscribe((res:any) =>{
      if(res.error){
        swal("Oops!!",res.message,"error");
        return;
      }
      this.contents = res.data;      
      swal("Success",res.message,"success");
      this.route.navigate(["./template"])
      return;
    })
    return;
  }

  previewTemlate(index:any){
    //alert("========"+index);
    this.preview_content = this.contents[index].content;
   //$("#previewHtmlModal").dialog("show");
    $('#previewHtmlModal').modal('show');
    return false;
  }

  editTemplate(){
    let template_id = this.routeActive.snapshot.paramMap.get('id'); 
    let project_id = this.project_list;
    let category_list = this.category_list;
    let content_type = this.content_type;    
    let template_name = this.template_name;
    let mail_subject = this.mail_subject;
    let mail_conent = $("#summernote").summernote('code');  

    console.log({
      id: template_id,
      project : project_id,
      category: category_list,
      content_type : content_type,
      name : template_name,
      mail_subject,
      content : mail_conent
    })
    ;

    this.authService.editTemplate({
      id: template_id,
      project : project_id,
      category: category_list,
      content_type : content_type,
      name : template_name,
      mail_subject,
      content : mail_conent
    }).subscribe((res:any) =>{
      if(res.error){
        swal("Oops!!",res.message,"error");
        return;
      }
      this.contents = res.data;      
      swal("Success",res.message,"success");
      this.route.navigate(["./template"])
      return;
    })
  }

}

$(document).ready(function() {  
  $('#summernote').summernote();
});





// WEBPACK FOOTER //
// /home/lynkit/Downloads/staging-boltseal/boltseal/newsletter-client/src/app/template/template.component.ts